export class PliConstants {
  public static readonly PLI_ROUNDING = {
    DECIMAL_ROUND_TO: 4,
    PERCENTAGE_ROUND_TO: 2,
    BERRY_RATIO: 4,
    UNIT_PRICE: 2
  };
}